import Settings from '@/pages/Settings'

// export default {
//     path: '/settings',
//     name: 'Settings',
//     component: Settings
// }

export default {
    path: '',
    component: Settings,
    children: [
      {
        path: '/settings',
        name: 'Settings',
        component: Settings,
      },
      {
        path: '/settings/profile',
        name: 'Profile Settings',
        component: Settings,
      },
      {
        path: '/settings/set/profile',
        name: 'Set Profile Settings',
        component: Settings,
      },
      {
        path: '/settings/edit/profile',
        name: 'Edit Profile Settings',
        component: Settings,
      },
      {
        path: '/settings/business/details',
        name: 'Business Details',
        component: Settings,
      },
      {
        path: '/settings/business/edit/details',
        name: 'Edit Business Details',
        component: Settings,
      },
      {
        path: '/settings/bankinformation',
        name: 'Bank Information',
        component: Settings,
      },
      {
        path: '/settings/business/location',
        name: 'Edit Business Location',
        component: Settings,
      },
      {
        path: '/settings/business/display/photos',
        name: 'Business Photos',
        component: Settings,
      },
      {
        path: '/settings/deliverylocations',
        name: 'Delivery Locations',
        component: Settings,
      },
      {
        path: '/settings/businessdeliverylocations',
        name: 'Buiness Delivery Locations',
        component: Settings,
      },
    ]
  }


// WEBPACK FOOTER //
// ./src/router/settings.js